<div class="row">
    <div class="col-lg-12">
        <ol class="breadcrumb">
            <li>
                <a (click)="$state.go('missioncontrol.dashboard', {}, {reload: true})" class="cursor-pointer">Home</a>
            </li>
            <li [ngClass]="{active: managers.length === 0}">
                <a (click)="getAllUsers()" class="cursor-pointer">
                    <span>Users</span>
                </a>
            </li>
            <li *ngFor="let manager of managers; let i = index"
                [ngClass]="{active: i === managers.length - 1}">
                <a (click)="viewManagerReportees(manager)" class="cursor-pointer">
                    <span [title]="manager.firstName + ' ' + manager.lastName"
                        *ngIf="manager.lastName !== null">
                        {{(manager.firstName + ' ' + manager.lastName) | slice:0:55}}
                        <span *ngIf="(manager.firstName + ' ' + manager.lastName).length > 55">... </span>
                    </span>
                    <span [title]="manager.firstName" *ngIf="manager.lastName === null">
                        {{manager.firstName | slice:0:55}}
                        <span *ngIf="manager.firstName.length > 55">... </span>
                    </span>
                </a>
            </li>
        </ol>
        <h1 class="heading-css">
            <span class="heading-css" *ngIf="managers.length === 0">Users</span>
            <span [title]="currentManager ? currentManager.firstName : ''"
                *ngIf="managers.length !== 0 && currentManager && currentManager.lastName === null">
                <b><i>{{(currentManager ? currentManager.firstName : '') | slice:0:55}}
                <span *ngIf="(currentManager ? currentManager.firstName : '').length > 55">... </span>'s</i></b>
                Direct Reports
            </span>
            <span [title]="(currentManager ? currentManager.firstName : '') + ' ' + (currentManager ? currentManager.lastName : '')"
                *ngIf="managers.length !== 0 && currentManager && currentManager.lastName !== null">
                <b><i>{{((currentManager ? currentManager.firstName : '') + ' ' + (currentManager ? currentManager.lastName : '')) | slice:0:55}}
                <span *ngIf="((currentManager ? currentManager.firstName : '') + ' ' + (currentManager ? currentManager.lastName : '')).length > 55">... </span>'s</i></b>
                Direct Reports
            </span>
        </h1>
    </div>
</div>

<div class="row">
    <app-users
        [iconClicked]="iconClicked"
        [managerDetails]="managerObj"
        [fromManagerCard]="fromManagerCard"
        [(currentManager)]="currentManager"
        [(managers)]="managers">
    </app-users>
</div>
